import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody, Modal, ModalHeader, ModalBody, CardHeader, CardText, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, TabContent, TabPane, Nav, NavItem, NavLink, Form, Input, Label, CardLink, FormGroup, ModalFooter } from 'reactstrap'
import Header from '../../Componentes/header'
import Navigation from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import ReactFileReader from 'react-file-reader'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify';
import { ip } from '../../Auxiliares/ip'
import Banner from '../../Img/Banner.png'
import SideBar from '../../Img/SideBar.png'


export default class AdminUsuarios extends Component {
    constructor() {
        super();
        this.state = {
            isViewModalOpen: null,
            advertencia: 'Las palabras referenciadas no pueden contener espacios o caracteres especiales (simbolos, acentos, etc.)',
            data: [
                { nombre: 'Agregar aspirantes (1ra vez)', campos: ["Nombre", "Apellido_Paterno", "Apellido_Materno", "Curp", "Ficha", "Sexo", "Nacionalidad", "Correo"], mensaje: "Este listado de campos seran considerados como requeridos\n Sexo: F = Femenino, M = Masculino" },
                { nombre: 'Activacion aspirantes (modificacion)', campos: ["Ficha", "Activa"], mensaje: "El valor correspondiente a la columna Activo debe ser (SI o NO) como indicador de estado" },

                { nombre: 'Aprobar estado de pago (1ra vez)', campos: ["Ficha"], mensaje: "" },
                { nombre: 'Cambiar estado de pago (modificacion)', campos: ["Ficha", "Pago"], mensaje: "El valor correspondiente a la columna pago debe ser Aprobado, Rechazado o Pendiente" },

                { nombre: 'Asignar aspirantes (1ra vez)', campos: ["Ficha", "Asesor"], mensaje: "El valor correspondiente a la columna Asesor debe ser el nombre usuario de dicho asesor" },

                { nombre: 'Agregar usuarios (1ra vez)', campos: ["Nombre", "Apellido_Paterno", "Apellido_Materno", "RFC", "Rol", "Contraseña", "Usuario", "Correo"], mensaje: "El valor correspondiente a la columna Rol debe correspomder a los siguientes valores: administrador, personal o auxiliar" },
                { nombre: 'Agregar datos de nuevo ingreso (1ra vez)', campos: ["Ficha", "Numero de control", "Contraseña", "Nip"], mensaje: "" },
            ],
            file: "",
            asignacion: []
        }

        this.toggleView = this.toggleView.bind(this);
        this.upload = this.upload.bind(this);
    }

    toggleView(index) {
        if (index >= 0) {
            this.setState({ isViewModalOpen: index, asignacion: [] });
        } else {
            this.setState({ isViewModalOpen: null });
        }
    }

    handleFile = (file) => {
        this.setState({ file: [file.base64] })
    }

    upload() {
        var index = this.state.isViewModalOpen;
        switch (index) {
            case 0:
                Fetch('/agregarAspirantesExcel', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ excel: this.state.file, asig_nombre: this.state.asignacion[0], asig_ap_paterno: this.state.asignacion[1], asig_ap_materno: this.state.asignacion[2], asig_curp: this.state.asignacion[3], asig_ficha: this.state.asignacion[4], asig_sexo: this.state.asignacion[5], asig_nacionalidad: this.state.asignacion[6], asig_correo: this.state.asignacion[7] })
                })
                    .then(response => {
                        toast.success("Operacion realizada correctamente")
                    })
                    .catch(err => {
                        toast.error("Error al realizar la operacion: " + err)
                    })
                break;

            case 1:
                Fetch('/activacionAspirantesExcel', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ excel: this.state.file, asig_ficha: this.state.asignacion[0], asig_activa: this.state.asignacion[1] })
                })
                    .then(response => {
                        toast.success("Operacion realizada correctamente")
                    })
                    .catch(err => {
                        toast.error("Error al realizar la operacion: " + err)
                    })
                break;

            case 2:
                Fetch('/aprobarPagoAspirantesExcel', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ excel: this.state.file, asig_ficha: this.state.asignacion[0] })
                })
                    .then(response => {
                        toast.success("Operacion realizada correctamente")
                    })
                    .catch(err => {
                        toast.error("Error al realizar la operacion: " + err)
                    })
                break;

            case 3:
                Fetch('/cambiarPagoAspirantesExcel', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ excel: this.state.file, asig_ficha: this.state.asignacion[0], asig_pago: this.state.asignacion[1] })
                })
                    .then(response => {
                        toast.success("Operacion realizada correctamente")
                    })
                    .catch(err => {
                        toast.error("Error al realizar la operacion: " + err)
                    })
                break;

            case 4:
                Fetch('/asignarAspirantesExcel', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ excel: this.state.file, asig_ficha: this.state.asignacion[0], asig_asesor: this.state.asignacion[1] })
                })
                    .then(response => {
                        toast.success("Operacion realizada correctamente")
                    })
                    .catch(err => {
                        toast.error("Error al realizar la operacion: " + err)
                    })
                break;

            case 5:
                Fetch('/agregarUsuariosExcel', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ excel: this.state.file, asig_nombre: this.state.asignacion[0], asig_ap_paterno: this.state.asignacion[1], asig_ap_materno: this.state.asignacion[2], asig_rfc: this.state.asignacion[3], asig_rol: this.state.asignacion[4], asig_contraseña: this.state.asignacion[5], asig_usuario: this.state.asignacion[6], asig_correo: this.state.asignacion[7] })
                })
                    .then(response => {
                        toast.success("Operacion realizada correctamente")
                    })
                    .catch(err => {
                        toast.error("Error al realizar la operacion: " + err)
                    })
                break;

            case 6:
                Fetch('/agregarDatosNuevoIngresoExcel', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ excel: this.state.file, asig_ficha: this.state.asignacion[0], asig_noControl: this.state.asignacion[1], asig_contraseña: this.state.asignacion[2], asig_nip: this.state.asignacion[3] })
                })
                    .then(response => {
                        toast.success("Operacion realizada correctamente")
                    })
                    .catch(err => {
                        toast.error("Error al realizar la operacion: " + err)
                    })
                break;

        }
    }


    input(index, inputValue) {
        var newArray = this.state.asignacion;
        newArray[index] = inputValue;

        this.setState({ asignacion: newArray })
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Navigation usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>
                                    <Card className="mt-3 mb-3 p-4" >
                                        <h1 className="display-4">Subir a Base de datos</h1>
                                        <p className="lead">Esta seccion permite modificar la informacion a traves de documentos Excel</p>
                                        <hr className="my-1" />
                                    </Card>
                                    <div>
                                        <Card className="mb-4">
                                            <Row className="mt-2 mb-2 d-flex justify-content-center">
                                                {this.state.data.map((value, index) => (
                                                    <Col xs="11" md={index < 6 ? "3" : "11"} className={index < 6 ? "mx-2 my-2 d-flex justify-content-center" : "my-2 text-center d-flex justify-content-center"}>
                                                        {index < 6 &&
                                                            <Button className="col-12 list-group-item"
                                                                style={{
                                                                    background: `url(${SideBar})`, backgroundSize: 'cover', backgroundPosition: 'center', height: "100px"
                                                                }}
                                                                onClick={() => this.toggleView(index)}
                                                            > {value.nombre} </Button>
                                                        }
                                                        {index == 6 &&
                                                            <Button className="col-10 list-group-item"
                                                                style={{
                                                                    background: `url(${SideBar})`, backgroundSize: 'cover', backgroundPosition: 'center', height: "100px"
                                                                }}
                                                                onClick={() => this.toggleView(index)}
                                                            > {value.nombre} </Button>
                                                        }
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Card>
                                    </div>

                                    <Modal className="color-dark" isOpen={this.state.isViewModalOpen != null} toggle={() => this.toggleView()}
                                        className="modal-lg">
                                        <ModalHeader
                                            style={{
                                                background: `url(${Banner}) center`,
                                                backgroundSize: 'cover', backgroundPosition: 'center-left'
                                            }}
                                            className="text-white" toggle={() => this.toggleView()}>{this.state.isViewModalOpen != null ? this.state.data[this.state.isViewModalOpen].nombre : ''}</ModalHeader>
                                        <ModalBody>
                                            <Row className="ml-5 mr-5">
                                                <Label className="font-weight-bold">{this.state.isViewModalOpen != null ? this.state.data[this.state.isViewModalOpen].mensaje : ""}</Label>
                                                {this.state.isViewModalOpen != null ? this.state.data[this.state.isViewModalOpen].campos.map((value, index) => (
                                                    <Col className="col-6">
                                                        <FormGroup className="p-1">
                                                            <Label for="value">{value}</Label>
                                                            <Input type="text" className="w-100" onChange={(e) => this.input(index, e.target.value)}></Input>
                                                        </FormGroup>
                                                    </Col>
                                                )) : ''}
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter
                                            style={{
                                                background: `url(${SideBar}) center`,
                                                backgroundSize: 'cover', backgroundPosition: 'center-left'
                                            }} 
                                            className="text-center d-flex justify-content-center">
                                                <Col xs="12" className="mt-2 mb-1">
                                                    <Button className="btn-info">
                                                        <ReactFileReader
                                                            fileTypes={[".xlsx"]} base64={true} multipleFiles={false} handleFiles={this.handleFile}>Seleccionar documento</ReactFileReader>
                                                    </Button>
                                                </Col>

                                                <Col xs="12" className="mb-2 mt-1">
                                                    <Button className="btn-info" onClick={this.upload}>Subir</Button>
                                                </Col>
                                            </ModalFooter>
                                    </Modal>
                                </Container>
                            </div>
                        </div>
                    </Col>

                </Row>
                <Footer />
            </html>
        )
    }
}
